import * as React from 'react'

import { LinkButton, ButtonToolbar } from '../Styled/Shared'
import { Page } from '../Styled/Pages'
import styled from '../../theme/styled'
import { getWithSpaceTypes, SpaceTypeProps } from './spaceTypeQueries'
import { renderIndicator } from '../Shared/LoadIndicators'
import Tooltip from './../Shared/Tooltip'
import Error from './../Shared/Alerts/Error'

import { SpaceTypeLi, SpaceTypes, InfoTipWrapper } from './SpaceTypeStyles'

const infoButton = require('./ic_info.svg')
const tooltips = require('../Shared/tooltips.json')

/* stylelint-disable */
const SpaceTypeWrapper = styled(Page)``
/* stylelint-enable */

type InputProps = {
  selectedType: string
  select: (typeId: string) => void
}

type TTProps = {
  id: string
  pos: { x: number; y: number }
  maxWidth?: number
}

type State = {
  tooltip: TTProps
  error: string | undefined
}

export function truncate(str?: string): string {
  if (!str) {
    return ''
  }

  const ellipsis = str.length > 40 ? '...' : ''

  return str.substring(0, 40) + ellipsis
}

const SpaceTypeItem = ({
  id,
  displayName,
  description,
  detail,
  selected,
  onSelect,
  mouseEnter,
  mouseLeave,
  tooltip
}: {
  id: string
  displayName: string
  description?: string
  detail?: string
  selected: boolean
  onSelect: (id: string) => void
  mouseEnter: (event: React.MouseEvent<HTMLElement>) => void
  mouseLeave: (event: React.MouseEvent<HTMLElement>) => void
  tooltip: TTProps
}) => (
  <SpaceTypeLi
    selected={selected}
    key={id}
    id={id}
    onClick={() => onSelect(id)}
    onMouseEnter={mouseEnter}
    onMouseLeave={mouseLeave}
  >
    <div className="contentWrapper">
      <div className="title-line">
        <p>
          {description}
          <br />
          <span>{detail}</span>
        </p>
        <h3>{displayName}</h3>
      </div>
      <img
        src={process.env.PUBLIC_URL + `/spaces/${id}.svg`}
        className="pictogram"
      />
    </div>
    <Tooltip
      tooltip={{
        text: tooltips.spaceTypes[displayName],
        show: tooltip.id === id,
        pos: tooltip.pos,
        maxWidth: tooltip.maxWidth
      }}
    />
  </SpaceTypeLi>
)

class SpaceTypeSelect extends React.Component<
  SpaceTypeProps & InputProps,
  State
> {
  constructor(props: SpaceTypeProps & InputProps) {
    super(props)
    this.state = {
      tooltip: { id: '', pos: { x: 0, y: 0 }, maxWidth: 0 },
      error: undefined
    }

    this.showTooltip = this.showTooltip.bind(this)
    this.hideTooltip = this.hideTooltip.bind(this)
  }

  select = (id: string) => {
    this.props.select(id)
  }

  componentDidMount() {
    if (
      !this.props.loading &&
      (!this.props.spaceTypes || this.props.spaceTypes.length < 1)
    ) {
      this.setState({ error: 'Could not load spaceTypes.' })
    }
  }

  showTooltip(event: React.MouseEvent<HTMLElement>) {
    const id = event.currentTarget.getAttribute('id')
    if (!id) {
      return
    }
    const rect = event.currentTarget.getBoundingClientRect()
    this.setState({
      tooltip: {
        id: id,
        pos: {
          x: rect.left + rect.width / 2,
          y: rect.top
        },
        maxWidth: rect.width + 10
      }
    })
  }

  hideTooltip() {
    this.setState({ tooltip: { ...this.state.tooltip, id: '' } })
  }

  render() {
    const { spaceTypes, loading, error, selectedType } = this.props

    if (loading || error) {
      return renderIndicator(loading, error)
    }

    if (this.state.error) {
      return (
        <Error onDismiss={() => this.setState({ error: undefined })}>
          Could not load spacetypes.
        </Error>
      )
    }

    return (
      <SpaceTypeWrapper>
        {spaceTypes && (
          <div className="content">
            <h2>Please select category of use for your design area</h2>
            <p>Affects the default category and load values.</p>
            <InfoTipWrapper>
              <Tooltip
                tooltip={{
                  text: tooltips.spaceTypes.info,
                  show: this.state.tooltip.id === 'infoButton',
                  pos: this.state.tooltip.pos,
                  width: 200
                }}
              />
              <img
                id={'infoButton'}
                className="button"
                src={infoButton}
                onMouseEnter={this.showTooltip}
                onMouseLeave={this.hideTooltip}
              />
            </InfoTipWrapper>
            <SpaceTypes>
              {spaceTypes.map(bt => (
                <SpaceTypeItem
                  key={bt.id}
                  {...bt}
                  selected={selectedType === bt.id}
                  onSelect={this.select}
                  mouseEnter={this.showTooltip}
                  mouseLeave={this.hideTooltip}
                  tooltip={this.state.tooltip}
                />
              ))}
            </SpaceTypes>
            <ButtonToolbar>
              <LinkButton className="secondary" to="/location">
                Previous
              </LinkButton>
              <LinkButton to="/project/new/workspace">Next</LinkButton>
            </ButtonToolbar>
          </div>
        )}
      </SpaceTypeWrapper>
    )
  }
}

export default getWithSpaceTypes<InputProps>()(SpaceTypeSelect)



// WEBPACK FOOTER //
// ./src/Components/SpaceTypeSelect/SpaceTypeSelector.tsx